var map = {
	"./infoMinigame-1/image-rock-1.png": 275,
	"./infoMinigame-1/image-rock-2.png": 276,
	"./infoMinigame-1/image-rock-3.png": 277,
	"./infoMinigame-1/rock-1-A1.png": 278,
	"./infoMinigame-1/rock-1-A2.png": 279,
	"./infoMinigame-1/rock-1-A3.png": 280,
	"./infoMinigame-1/rock-1-A4.png": 281,
	"./infoMinigame-1/rock-1-B1.png": 282,
	"./infoMinigame-1/rock-1-B2.png": 283,
	"./infoMinigame-1/rock-1-B3.png": 284,
	"./infoMinigame-1/rock-1-B4.png": 285,
	"./infoMinigame-1/rock-1-C1.png": 286,
	"./infoMinigame-1/rock-1-C2.png": 287,
	"./infoMinigame-1/rock-1-C3.png": 288,
	"./infoMinigame-1/rock-1-C4.png": 289,
	"./infoMinigame-1/rock-1-D1.png": 290,
	"./infoMinigame-1/rock-1-D2.png": 291,
	"./infoMinigame-1/rock-1-D3.png": 292,
	"./infoMinigame-1/rock-1-D4.png": 293,
	"./infoMinigame-1/rock-2-A1.png": 294,
	"./infoMinigame-1/rock-2-A2.png": 295,
	"./infoMinigame-1/rock-2-A3.png": 296,
	"./infoMinigame-1/rock-2-A4.png": 297,
	"./infoMinigame-1/rock-2-B1.png": 298,
	"./infoMinigame-1/rock-2-B2.png": 299,
	"./infoMinigame-1/rock-2-B3.png": 300,
	"./infoMinigame-1/rock-2-B4.png": 301,
	"./infoMinigame-1/rock-2-C1.png": 302,
	"./infoMinigame-1/rock-2-C2.png": 303,
	"./infoMinigame-1/rock-2-C3.png": 304,
	"./infoMinigame-1/rock-2-C4.png": 305,
	"./infoMinigame-1/rock-2-D1.png": 306,
	"./infoMinigame-1/rock-2-D2.png": 307,
	"./infoMinigame-1/rock-2-D3.png": 308,
	"./infoMinigame-1/rock-2-D4.png": 309,
	"./infoMinigame-1/rock-3-A1.png": 310,
	"./infoMinigame-1/rock-3-A2.png": 311,
	"./infoMinigame-1/rock-3-A3.png": 312,
	"./infoMinigame-1/rock-3-A4.png": 313,
	"./infoMinigame-1/rock-3-B1.png": 314,
	"./infoMinigame-1/rock-3-B2.png": 315,
	"./infoMinigame-1/rock-3-B3.png": 316,
	"./infoMinigame-1/rock-3-B4.png": 317,
	"./infoMinigame-1/rock-3-C1.png": 318,
	"./infoMinigame-1/rock-3-C2.png": 319,
	"./infoMinigame-1/rock-3-C3.png": 320,
	"./infoMinigame-1/rock-3-C4.png": 321,
	"./infoMinigame-1/rock-3-D1.png": 322,
	"./infoMinigame-1/rock-3-D2.png": 323,
	"./infoMinigame-1/rock-3-D3.png": 324,
	"./infoMinigame-1/rock-3-D4.png": 325,
	"./infoMinigame-2/graph-common.png": 163,
	"./infoMinigame-2/graph-kitchen.png": 164,
	"./infoMinigame-2/graph-office.png": 165,
	"./infoMinigame-2/graph-reactor.png": 166,
	"./infoMinigame-2/graph-workshop-lab.png": 167,
	"./infoMinigame-2/rooms.png": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 185;